(function () {
  const flickityCarousel = () => {
    $(".flickity-carousel-section").each(function () {
      if ($(this).hasClass("slider_started")) {
        return "";
      }
      $(this).addClass("slider_started");
      const id = $(this).attr("id");
      const box = $(this).find(".flickity-carousel");
      const autoplay = box.data("autoplay");
      const speed = box.data("speed") * 1000;
      const stopAutoplay = box.data("stop-autoplay");
      const delay = box.data("delay") * 1000;
      const blockSize = box.data("blocks-size");

      let size = false;
      if (blockSize > 3) {
        size = true;
      }

      let autoplayParm = {};
      if (autoplay) {
        autoplayParm = {
          autoplay: {
            delay: delay,
            pauseOnMouseEnter: stopAutoplay,
            disableOnInteraction: false,
          },
        };
      }

      let swiperParms = {
        speed: speed,
        slidesPerView: 1.4,
        centeredSlides: true,
        spaceBetween: 16,
        loop: size,
        loopPreventsSliding: false,
        breakpoints: {
          576: {
            spaceBetween: 24,
            slidesPerView: 1.6,
          },
          750: {
            spaceBetween: 40,
            slidesPerView: 1.8,
          },
          990: {
            spaceBetween: 60,
            slidesPerView: 2,
          },
          1200: {
            spaceBetween: 80,
            slidesPerView: 2.2,
          },
          1600: {
            spaceBetween: 100,
            slidesPerView: 2.4,
          },
        },
        navigation: {
          nextEl: `#${id} .swiper-button-next`,
          prevEl: `#${id} .swiper-button-prev`,
        },
        pagination: {
          el: `#${id} .swiper-pagination`,
          clickable: true,
        },
        ...autoplayParm,
      };

      const swiper = new Swiper(`#${id} .swiper`, swiperParms);

      gsap.fromTo(
        `#${id} .swiper-slide`,
        { opacity: 0, y: 50 },
        { opacity: 1, y: 0, duration: 0.5, stagger: 0.2 }
      );

      gsap.to(`#${id} .swiper-slide-prev, #${id} .swiper-slide-next`, {
        scale: 0.9,
        duration: delay / 1000,
      });

      swiper.on("slideChangeTransitionStart", function () {
        gsap.to(`#${id} .swiper-slide`, { scale: 1, duration: delay / 1000 });
        gsap.to(`#${id} .swiper-slide-prev, #${id} .swiper-slide-next`, {
          scale: 0.9,
          duration: delay / 1000,
        });
      });
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    flickityCarousel();
    document.addEventListener("shopify:section:load", function () {
      flickityCarousel();
    });
  });
})();